<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>

      <section>

        <!-- 焦点图 -->
        <div class="banner-box">
          <K-Swiper :datas="datas.focus" :auto="true" v-if="datas.focus && datas.focus_pics_is_show == 1"></K-Swiper>
        </div>

        <div class="box">

            <!-- 导航菜单 -->
        		<div class="menu" v-if="datas.menu">
        			<div class="nav-item" v-for="(item, index) in datas.menu" v-bind:key="index" @click="ClickMenu(item)">
        				<img :src="item.icon">
        				<span v-text="item.name"></span>
        			</div>
              <div class="nav-item" v-for="item in (6 - datas.menu.length)" @click="ClickMenu()">
              	<img :src="`/static/images/pesticide/icon_0${item}.png`">
              	<span>防伪溯源</span>
              </div>
        		</div>

            <!-- 产品信息 -->
        		<div class="info">
        			<div class="title">溯源码</div>
        			<div class="code" v-text="code"></div>
        			<div class="list">
                <K-Form :datas="formObj.formProduct"></K-Form>
        			</div>
        		</div>

        </div>
      </section>

      <!-- 弹窗 -->
      <K-AlertMsg :AlertMsg="AlertMsg" @AlertBack="AlertBack"></K-AlertMsg>

    </div>
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import AlertMsg from '@/components/AlertMsg.vue'
import Form from '@/components/Form.vue'
import KSwiper from '@/components/Swiper.vue'
import mixin from '../mixins/mixin.js'
export default {
  name: 'Pesticide06',
  components: {
    'K-Loading': Loading,
    'K-AlertMsg': AlertMsg,
    'K-Form': Form,
    KSwiper,
  },
  mixins: [mixin],
  data() {
    return {
      isShow: false,
      formObj: {
        formProduct: {
          url: {
            label: '溯源网址',
            value: 'http://oid.plus'
          },
          scan_count: {
            label: '查询次数',
            value: ''
          },
          scan_first_time: {
            label: '查询时间',
            value: ''
          },
          name: {
            label: '产品名称',
            value: ''
          },
          alias_name: {
            label: '农药名称',
            value: ''
          },
          batch: {
            label: '生产批次',
            value: ''
          },
          attribute: {
            type: 'attribute',
            label: '自定义属性',
            value: ''
          },
          reg_code_owner: {
            label: '登记证持有人',
            value: ''
          }
        }
      }
    }
  },
  created() {
    document.querySelector('body').setAttribute('style', 'background-color:#f4f5f6');
    this.initData();
  },
  methods: {
    async initData(){
      //判断是演示还是真实码标
      if (this.$route.query.type == "demo") {
        const pid = this.$route.query.pid; //产品ID
        const rid = this.$route.query.rid; //企业ID
        this.GetDemoDatas(pid, rid);  //获取演示模板信息
      } else {
        await this.GetDatas();  //获取码标信息
        const product = this.datas.product;
        product.scan_count = this.datas.scan_count; //扫码次数
        product.scan_first_time = this.datas.scan_first_time; //扫码时间
        product.batch = this.datas.batch.name; //产品批次
        this.formObj.formProduct.attribute.value = product.attribute; //自定义属性设置
        this.setFormContent(this.formObj.formProduct, product); //产品表单内容
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .banner-box{
    min-height: 230px;
  }
  .box{
  	position: absolute;
    z-index: 9;
    top: 4rem;
    margin: 0 20px;
    background-color: #f4f5f6;
    padding: 7px;
    border-radius: 10px;
    padding-bottom: 20px;
  }

  /* 菜单 */
  .menu{
  	display: flex;
  	flex-wrap: wrap;
  	justify-content: space-between;
    .nav-item{
    	width: calc(33.33% - 3px);
    	padding: 20px 0;
    	background-color: #fff;
    	margin-bottom: 6px;
      font-size: 1em;
      img{
      	width: 40%;
      	max-width: 80px;
      	display: table;
      	margin: 0 auto;
      }
      span{
      	display: block;
      	text-align: center;
      	margin-top: 8px;
      }
    }
    :nth-child(1){
    	border-radius: 10px 0 0 0;
    }
    :nth-child(3){
    	border-radius: 0 10px 0 0;
    }
    :nth-child(4){
    	border-radius: 0 0 0 10px;
    }
    :nth-child(6){
    	border-radius: 0 0 10px 0;
    }
  }

  /* 列表 */
  .info{
  	background-color: white;
  	border-radius: 10px;
  	padding: 20px 20px 0 20px;
  	margin-top: 10px;
    .title{
    	text-align: center;
    	font-size: 1.3em;
    	font-weight: bold;
    }
    .code{
    	color: #2e77f9;
    	margin-top: 10px;
    	padding: 15px 20px;
    	text-align: center;
    	font-size: 1em;
      line-height: 1em;
    	font-weight: bold;
    	border-radius: 100px;
    	background-color: #f9fafc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/Pesticide06.vue